// Example: How to modify existing rules
import { BOOTH_RULES_CONFIG } from '../services/boothRulesService';

// Option 1: Create a custom configuration by modifying the base config
export const CUSTOM_BOOTH_RULES = {
  ...BOOTH_RULES_CONFIG,
  
  // Disable corner adjacency rule
  CORNER_ADJACENCY: {
    ...BOOTH_RULES_CONFIG.CORNER_ADJACENCY,
    enabled: false
  },
  
  // Enable minimum purchase rule with different settings
  MINIMUM_PURCHASE: {
    ...BOOTH_RULES_CONFIG.MINIMUM_PURCHASE,
    enabled: true,
    minBooths: 3, // Require at least 3 booths
    description: 'Each vendor must purchase at least 3 booths'
  },
  
  // Modify group purchase rule with your specific booth groups
  GROUP_PURCHASE: {
    ...BOOTH_RULES_CONFIG.GROUP_PURCHASE,
    enabled: true,
    groups: [
      {
        id: 'main-entrance',
        name: 'Main Entrance Premium Zone',
        booths: ['cell-1-1', 'cell-1-2', 'cell-1-3', 'cell-2-1', 'cell-2-2', 'cell-2-3'],
        description: 'High-traffic entrance area - complete block purchase required'
      },
      {
        id: 'food-court',
        name: 'Food Court Area',
        booths: ['cell-10-15', 'cell-10-16', 'cell-10-17', 'cell-10-18'],
        description: 'Food service area booths must be purchased together'
      }
    ]
  }
};

// Option 2: Runtime rule modification
export const modifyRulesAtRuntime = (currentRules) => {
  const modifiedRules = { ...currentRules };
  
  // Disable a rule
  modifiedRules.CORNER_ADJACENCY.enabled = false;
  
  // Change rule parameters
  modifiedRules.MINIMUM_PURCHASE.minBooths = 5;
  modifiedRules.MINIMUM_PURCHASE.enabled = true;
  
  // Add new booth groups
  modifiedRules.GROUP_PURCHASE.groups.push({
    id: 'tech-zone',
    name: 'Technology Zone',
    booths: ['cell-5-5', 'cell-5-6', 'cell-5-7', 'cell-6-5', 'cell-6-6', 'cell-6-7'],
    description: 'Technology showcase requires purchasing the entire group together'
  });
  
  return modifiedRules;
};